export default __webpack_public_path__ + "static/media/quiz-enabled.914713ae.svg";